import { call, select, spawn } from 'typed-redux-saga';

import { isRoomAgentMode } from '../../../../../shared/features/config/selectors';
import { goloomSdk } from '../../../../../shared/features/goloom-sdk';
import { setHeadlessViewportSaga } from '../../../../../shared/features/headless-browser';
import { waitForSettingsLoaded } from '../../../../../shared/features/settings/sagas';
import { createLogger } from '../../../../../shared/helpers/loggerFacade';
import { initMuteState } from '../../device';
import { initDevices } from '../../device/sagas/device';

const logger = createLogger('conference:init');

interface InitConferenceSagaParams {
    syncInitDevices?: boolean;
    reinit?: boolean;
}

export function* initConferenceSaga(params: InitConferenceSagaParams) {
    const { syncInitDevices, reinit } = params;
    const isRoomAgent = yield* select(isRoomAgentMode);

    // Ждём загрузки настроек из localStorage перед инициализацией конференции
    yield* call(waitForSettingsLoaded, 'initConferenceSaga', logger);

    yield* call(setHeadlessViewportSaga);

    if (reinit) {
        yield* call([goloomSdk, goloomSdk.reinit]);
    } else {
        yield* call([goloomSdk, goloomSdk.init]);
    }

    if (isRoomAgent) {
        return;
    }

    yield* call(initMuteState, { forceCurrentState: reinit });
    if (syncInitDevices) {
        yield call(initDevices);
    } else {
        yield spawn(initDevices);
    }
}
